import PurchasingAPIService from '@/modules/purchasing/services/apiService'

import ReportView  from '@/modules/reporting/views/report.vue'

export default class PurchasingModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.purchasingService = new PurchasingAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/purchasing/purchaseorders',
        name: 'PurchaseOrderList',
        component: () => import('@/modules/purchasing/views/purchaseOrderList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Purchase Orders',
          menuLink: '/purchasing/purchaseorders',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/purchasing/purchaseorders/new',
        name: 'PurchaseOrderNew',
        component: () => import('@/modules/purchasing/views/purchaseOrderNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'New Purchase Order',
          menuLink: '/purchasing/purchaseorders',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Purchase Orders', link: '/purchasing/purchaseorders'}
          ],
        }
      },
      {
        path: '/purchasing/purchaseorders/:id',
        name: 'PurchaseOrder',
        component: () => import('@/modules/purchasing/views/purchaseOrder.vue'),
        meta: {
          requiresAuth: true,
          title: 'Purchase Order',
          menuLink: '/purchasing/purchaseorders',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Purchase Orders', link: '/purchasing/purchaseorders'}
          ],
        }
      },
      {
        path: '/purchasing/purchaseorders/:id/report',
        name: 'PurchaseOrderReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Purchase Order Report',
          layout: 'Blank',
          report: {
            url: '/reporting/purchaseorders/:id/report',
            variables: ['id'],
            options: ['hidePrices']
          },
        }
      },
      {
        path: '/purchasing/purchaseorders/:id/receivesheetreport',
        name: 'PurchaseOrderReceiveSheetReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Purchase Order - Receiving Sheet Report',
          layout: 'Blank',
          report: {
            url: '/reporting/purchaseorders/:id/receivesheetreport',
            variables: ['id']
          },
        }
      },
      {
        path: '/purchasing/purchaseorders/:id/receiving/labels',
        name: 'PurchaseOrderReceivedGoodsLabels',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Purchase Order - Received Goods Labels',
          layout: 'Blank',
          report: {
            url: '/purchasing/purchaseorders/:id/receiving/labels',
            variables: ['id']
          },
        }
      },
      {
        path: '/purchasing/purchaseorders/:id/receiving/labels/:itemId',
        name: 'PurchaseOrderReceivedGoodsSingleLabel',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Purchase Order - Received Goods Labels',
          layout: 'Blank',
          report: {
            url: '/purchasing/purchaseorders/:id/receiving/labels/:itemId',
            variables: ['id', 'itemId']
          },
        }
      }
    ]
  }
}
